import React, { useState, useCallback, useEffect } from 'react';
import Order from './Order';
import RefundExchangeInfo from './RefundExchangeInfo';
import OrderAddress from '../../../../CommonComponents/OrderStatus/OrderAddress';
import PriceBreakUp from '../../../../CommonComponents/OrderStatus/PriceBreakUp';
import { userProperties } from '../../../../CommonComponents/UserPropertiesForGA/UserProperties';

export const OrderDetailContext = React.createContext();

function OrderDetail(props) {
  const {
    order,
    currencyMark,
    order: { amount, shippingAddress },
    userInfo,
    redisCommonData,
    history,
    match,
    dataLocale,
  } = props;
  const [showRefundExchangeInfo, showRefundExchangeInfoFunc] = useState(false);
  const refundExchangeInfoFunc = useCallback(() => {
    showRefundExchangeInfoFunc(!showRefundExchangeInfo);
  }, [showRefundExchangeInfo]);
  useEffect(() => {
    window.scrollTo(0, 0);
    userProperties(userInfo, 'order-detail-page', 'desktop', dataLocale)
  }, []);
  return (
    <React.Fragment>
      <div className="order-detail padding-t30 clearfix">
        <OrderDetailContext.Provider
          value={{ userInfo, orderStatusRedis: redisCommonData?.ORDER_STATUS, match }}
        >
          <Order
            email={userInfo.email}
            history={history}
            order={order}
            refundExchangeInfoFunc={refundExchangeInfoFunc}
          />
        </OrderDetailContext.Provider>
      </div>
      {showRefundExchangeInfo && <RefundExchangeInfo dataLocale={dataLocale} />}
      <div className="display-flex margin-b40 margin-l35 margin-r35">
        {shippingAddress && (
          <div className="flex-1 margin-r20">
            <OrderAddress address={shippingAddress} dataLocale={dataLocale} view="desktop" />
          </div>
        )}
        <div className="flex-1 margin-l20">
          <PriceBreakUp
            amount={amount}
            currencyMark={currencyMark}
            dataLocale={dataLocale}
            view="desktop"
          />
        </div>
      </div>
    </React.Fragment>
  );
}

export default OrderDetail;
